// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='1.25 1.25 21.5 21.5'
    ...attributes
  ><path fill='none' d='M0 0h24v24H0z' /><path
      fill='var(--icon-color, #000)'
      stroke='var(--icon-color, #000)'
      stroke-width='var(--icon-stroke-width, 0.7)'
      d='M4 20.75a.75.75 0 0 1-.75-.75v-4.181a.76.76 0 0 1 .22-.53L14.711 4.05a2.72 2.72 0 0 1 3.848 0l1.391 1.391a2.72 2.72 0 0 1 0 3.848L8.712 20.53a.75.75 0 0 1-.531.22zm.75-4.621v3.121h3.12l7.91-7.91-3.12-3.12zm12.091-5.849 2.051-2.051a1.223 1.223 0 0 0 0-1.727l-1.393-1.394a1.22 1.22 0 0 0-1.727 0L13.72 7.16z'
    /><path
      fill='none'
      stroke='var(--icon-background-color, #fff)'
      stroke-linecap='round'
      stroke-width='4'
      d='m3.25 3.25 17.5 17.5'
    /><path
      fill='none'
      stroke='var(--icon-color, #000)'
      stroke-linecap='round'
      stroke-width='2'
      d='m3.25 3.25 17.5 17.5'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconPencilCrossedOut';
export default IconComponent;
